import React from 'react';
import { createUseStyles } from 'react-jss';
import { theme } from '../../theme';

const styles = createUseStyles({
    loader: ({ width, height, borderWidth, borderColor, borderTopColor }) => ({
        borderColor,
        borderWidth,
        borderStyle: 'solid',
        borderTopColor,
        borderRadius: '50%',
        width: width || '50px',
        height: height || '50px',
        animation: 'spin 1.2s linear infinite',
        maxWidth: '100%'
    })
});
interface CircleLoaderProps {
    width?: string;
    height?: string;
    borderWidth?: string;
    borderColor?: string;
    borderTopColor?: string;
}
const CircleLoader = ({
    width = '50px',
    height = '50px',
    borderWidth = '4px',
    borderColor = '#fff',
    borderTopColor = theme.primaryColor
}: CircleLoaderProps) => {
    const classes = styles({
        width,
        height,
        borderWidth,
        borderColor,
        borderTopColor
    });
    return <div className={classes.loader} />;
};
export default CircleLoader;
